<template>
    <div class="preview_TS scrollBar_xy" id="preview">
        <div class="preview">
            <div class="graffiti">
                <canvas width="1070" height="1200" id="myCanvas"
                    @mousedown="graffitiDown($event)"
                ></canvas>
            </div>
            <div class="FCanvas_Page" :style="{height:previewHeight+'px'}">
                <div class="FCharsDrog"
                     v-for="(item,index) in dragElementList"
                     :style="{
                                     background:item.backColor,
                                     height:item.transF.height+'px',
                                     width:item.transF.width+'px',
                                     top:item.transF.y+'px',
                                     left:item.transF.x+'px',
                                     }">
                    <div class="charts_box" v-if="item.type === 0"
                         :id="'snap_shot_'+item.chartData.id"></div>
                    <div class="text_input" v-if="item.type === 1" v-html="item.content">
                    </div>
                    <img class="text_img"
                         draggable="false"
                         :src="item.imgUrl"
                         v-if="item.type === 2">
                    <svg class="text_svg" id="text_svg" v-if="item.type === 3">
                        <rect class="rect" v-if="item.svg.type === 'rect'" :width="item.transF.width"
                              :height="item.transF.height"
                              :style="{fill:item.svg.fillColor,stroke:item.svg.strokeColor,strokeWidth:item.svg.strokeWidth+'px'}"/>
                        <ellipse class="ellipse" v-if="item.svg.type === 'ellipse'"
                                 :cx="item.transF.width" :cy="item.transF.height"
                                 :rx="item.transF.width" :ry="item.transF.height"
                                 :style="{fill:item.svg.fillColor,stroke:item.svg.strokeColor,strokeWidth:item.svg.strokeWidth+'px'}"/>
                        <line class="line" v-if="item.svg.type === 'line'" x1="0" y1="0"
                              :x2="item.transF.width" :y2="item.transF.height"
                              style="stroke:rgb(99,99,99);stroke-width:2"/>
                    </svg>
                </div>
            </div>
            <div class="userList">
                <div>当前查询用户：</div>
                <ul>
                    &nbsp
                    <li v-for="(val,index) in userList">{{val}}</li>
                </ul>
            </div>
            <div class="noData" v-if="totalCountShow">暂无数据</div>
        </div>
        <div class="container_toolbar">
            <FSvg title="直线" color="#000"   IconSize="40" :class="{select:graffit.tool==='line'}" @click.native="setGraffitiTool('line')"></FSvg>
            <FSvg title="矩形" color="#000"   IconSize="40" :class="{select:graffit.tool==='rect'}" @click.native="setGraffitiTool('rect')"></FSvg>
            <FSvg title="圆形" color="#000"   IconSize="40" :class="{select:graffit.tool==='circle'}" @click.native="setGraffitiTool('circle')"></FSvg>
            <el-popover
                    placement="bottom"
                    width="200"
                    trigger="click"
                    @click.native="setGraffitiTool('poly')">
                <el-badge slot="reference" :value="graffit.bian" class="item" type="primary">
                    <FSvg  title="多边形" color="#000" IconSize="40" :class="{select:graffit.tool==='poly'}" ></FSvg>
                </el-badge>
                <el-input-number class="number bian"  v-model="graffit.bian" controls-position="right"  :min="3" :max="100"></el-input-number>
            </el-popover>
            <FSvg class="tool" color="#999" hoverColor="#999" title="分割"></FSvg>
            <FSvg title="铅笔" color="#000"   IconSize="40" :class="{select:graffit.tool==='pen'}" @click.native="setGraffitiTool('pen')"></FSvg>
            <FSvg title="橡皮" color="#000"   IconSize="40" :class="{select:graffit.tool==='eraser'}" @click.native="setGraffitiTool('eraser')"></FSvg>
            <FSvg class="tool" color="#999" hoverColor="#999" title="分割"></FSvg>
            <el-color-picker  popper-class="picker" v-model="graffit.color" show-alpha> </el-color-picker>
            <el-input-number class="number" v-model="graffit.linewidth" controls-position="right" ></el-input-number>
            <FSvg class="tool" color="#999" hoverColor="#999" title="分割"></FSvg>
            <FSvg title="描边" color="#000"   IconSize="40" :class="{select:graffit.style==='stroke'}" @click.native="setGraffitiFill('stroke')"></FSvg>
            <FSvg title="填充" color="#000"   IconSize="40" :class="{select:graffit.style==='fill'}" @click.native="setGraffitiFill('fill')"></FSvg>
            <FSvg class="tool" color="#999" hoverColor="#999" title="分割"></FSvg>
            <FSvg title="清空" color="#000"   IconSize="40" @click.native="cleanGraffiti()"></FSvg>
            <FSvg title="撤销" color="#000" @click.native="revokeGraffiti()"  IconSize="40"></FSvg>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/7 2:40 下午
     */
    import modules from '../../views/rearAllMain/charts/script/modules'
    import config from '@/assets/js/config';
    import {delAllData, getToken, getUser} from '@/assets/js/basis'
    import {
        //获取故事版内容详情
        getTeamSharingContent,
        //涂鸦更改提交
        setSaveGrafJson,
        //获取涂鸦
        getSaveGrafJson
    } from '@/assets/axios/teamSharing/setContents'

    export default {
        name: 'FIconBtn',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                totalCountShow: false,
                dragElementList: [],
                previewHeight: '',
                //人员列表
                userList: ['机器人1', '机器人2'],
                graffit:{
                    img:'',
                    color:'#409EFF',
                    linewidth:3,
                    bian:3,
                    tool:'line',
                    style:'stroke',
                    arr:[],
                    width:null,
                    height:null,
                }
            }
        },
        methods: {
            // 获取页面内容
            getElementContent(id) {
                if (id !== undefined) {
                    getTeamSharingContent({storyBoardID: id}).then((res) => {
                        if (res.code === 200) {
                            this.dragElementList = [];
                            res.data.dataTable.info.map((val) => {
                                let a = {};
                                a = JSON.parse(val.contentJson);
                                a.chartBoxId = val.id;
                                a.storyBoardID = val.storyBoardID;
                                if (a.type === 0) {
                                    this.createChart(a.chartData, a.chartBoxId);
                                }
                                this.dragElementList.unshift(a);
                            });
                            this.zIndexList = JSON.parse(res.data.dataTable.rankJson);
                            //根据zIndexList 重新排列 dragElementList
                            this.setElementContentIndexRefresh();
                            this.rearrangedragElementList('dragList');
                            this.previewHeight = res.data.dataTable.height;
                            // this.dragElementList = JSON.parse(res.data.dataTable[0].contentJson);
                            // this.canvasPage.height = res.data.dataTable[0].height;
                        }
                    })
                }
            },
            // 刷新dragElementList中的zindex
            setElementContentIndexRefresh() {
                this.zIndexList.map((zv) => {
                    this.dragElementList.map((ev) => {
                        if (zv.id === ev.chartBoxId) {
                            ev.transF.zIndex = zv.zIndex;
                        }
                    })
                });
            },
            //根据zIndex重新排列dragElementList
            rearrangedragElementList(type) {
                if (type === 'dragList') {
                    var len = this.dragElementList.length;
                    for (var i = 0; i < len - 1; i++) {
                        for (var j = 0; j < len - 1 - i; j++) {
                            // 相邻元素两两对比，元素交换，大的元素交换到后面
                            if (this.dragElementList[j].transF.zIndex < this.dragElementList[j + 1].transF.zIndex) {
                                var temp = this.dragElementList[j];
                                this.dragElementList[j] = this.dragElementList[j + 1];
                                this.dragElementList[j + 1] = temp;
                            }
                        }
                    }
                } else if (type === 'zIndex') {
                    var len = this.zIndexList.length;
                    for (var i = 0; i < len - 1; i++) {
                        for (var j = 0; j < len - 1 - i; j++) {
                            // 相邻元素两两对比，元素交换，大的元素交换到后面
                            if (this.zIndexList[j].zIndex < this.zIndexList[j + 1].zIndex) {
                                var temp = this.zIndexList[j];
                                this.zIndexList[j] = this.zIndexList[j + 1];
                                this.zIndexList[j + 1] = temp;
                            }
                        }
                    }
                    this.setElementContentIndexRefresh();
                }

            },
            //链接signalR
            linkSignalR(id) {
                this.signalr.start().then(() => {
                    this.signalr.invoke('InitUser', id, getUser().id);
                    this.signalr.on('ActionOnline', (code, data) => {
                        if (code === 200) {
                            this.signalr.on('ActionPush', (type, json, id) => {
                                this.setDragElementList(type, JSON.parse(json), id)
                            })
                            this.signalr.on('AnyOnline', (list) => {
                                this.userList = list;

                            })
                        }
                    })
                })
                this.signalGraf.start().then(() => {
                    this.signalGraf.invoke('InitUser', id, getUser().id);
                    this.signalGraf.on('GrafOnline', (code, data) => {
                        if (code === 200) {
                            this.setSaveGraffitiPicture('obtain');
                            // this.signalGraf.on('GrafHistory', (json,id) => {
                            // })
                            this.signalGraf.on('GrafJsonPush', (img,id) => {
                                // this.cleanGraffiti();
                                var obj = this.getCanvas().obj;
                                var img = new Image();
                                img.src = this.graffit.img;
                                obj.drawImage(img,0,0);
                            })
                        }
                    })
                })
            },
            //生成真实数据图表
            createChart(data, boxId) {
                let oData = data;
                if (boxId !== undefined) {
                    oData.id += boxId;
                }
                let modu = modules;
                let nodeData = oData;
                this.$nextTick(() => {
                    this.$store.dispatch('viewDPSnapshot', {modu, nodeData});
                })
            },
            //被动操作元素
            setDragElementList(type, json, id) {
                if (type === 'add') {
                    json.chartBoxId = id;
                    this.dragElementList.push(json);
                    if (json.type === 0) {
                        this.createChart(json.chartData, json.chartBoxId);
                    }
                } else if (type === 'revise') {
                    this.dragElementList.map((val, index) => {
                        if (val.chartBoxId === id) {
                            this.dragElementList[index] = json;
                            if (json.type === 0) {
                                this.createChart(json.chartData, json.chartBoxId);
                            }
                        }
                    })
                } else if (type === 'delete') {
                    this.dragElementList.map((val, index) => {
                        if (val.chartBoxId === id) {
                            this.dragElementList.splice(index, 1)
                        }
                    })
                }
                this.$forceUpdate()
            },
            //--涂鸦功能--
            //提交涂鸦 GrafJson为空获取涂鸦
            setSaveGraffitiPicture(type){
                this.graffit.img =  document.getElementById('myCanvas').toDataURL("image/png");
                setSaveGrafJson({
                    StoryBookID:this.id,
                    GrafJson:type==='obtain'?'':this.graffit.img
                }).then((res)=>{
                    if(res.code === 200){
                        if(type ==='obtain'){
                            this.graffit.img = res.data;
                            this.setInitGraffiti();
                            var obj = this.getCanvas().obj;
                            var img = new Image();
                            img.src = this.graffit.img;
                            img.onload = function(){
                                obj.drawImage(img,0,0);
                            }
                        }

                    }
                })
            },
            //初始化涂鸦
            setInitGraffiti(){
                var canvas = this.getCanvas().canvas;
                var screenWidth = 1495;
                var screenHeight = this.previewHeight;
                var width = screenWidth - 295;
                var height = screenHeight - 15 + 15;
                this.graffit.width = canvas.width = width;
                this.graffit.height = canvas.height = height;
            },
            //涂鸦按下时
            graffitiDown(e){
                var x, y, w, h;
                var lx, ly, lw, lh;
                var cutdata;
                let type = this.graffit.tool;
                let canvas =this.getCanvas().canvas;
                let obj =this.getCanvas().obj;
                var cutflag = false;
                let arr  = this.graffit.arr;
                x = e.offsetX;
                y = e.offsetY;
                if (type == "pen") {
                    obj.beginPath();
                    obj.moveTo(x, y);
                }
                if (type == "eraser") {
                    obj.clearRect(x - 5, y - 5, 10, 10);
                }
                if (cutflag && type == "cut") {
                    if (arr.length != 0) {
                        arr.splice(-1, 1);
                    }
                }
                var draw = new Draw(obj, {type: this.graffit.style, color: this.graffit.color, width: this.graffit.linewidth});//实例化构造函数
                canvas.onmousemove = (e)=>{
                    w = e.offsetX;
                    h = e.offsetY;
                    if (type != "eraser") {
                        // obj.clearRect(0, 0, width, height);
                        if (arr.length != 0) {
                            obj.putImageData(arr[arr.length - 1], 0, 0, 0, 0, this.graffit.width, this.graffit.height);
                        }else {
                            return
                        }
                    }
                    if (cutflag && type == "cut") {
                        if (iscut) {
                            obj.clearRect(lx, ly, lw - lx, lh - ly);
                        }
                        var nx = lx + (w - x);
                        var ny = ly + (h - y);
                        obj.putImageData(cutdata, nx, ny);
                    } else if (type == "poly") {
                        draw[type](x, y, w, h, this.graffit.bian);
                    } else {
                        draw[type](x, y, w, h);
                    }

                }
                document.onmouseup = ()=>{
                    canvas.onmousemove = null;
                    document.onmouseup = null;
                    if (type == "cut") {
                        if (!cutflag) {
                            cutflag = true;
                            cutdata = obj.getImageData(x + 1, y + 1, w - x - 2, h - y - 2);
                            lx = x;
                            ly = y;
                            lw = w;
                            lh = h;
                            $(".container").css({display: "none"});
                        } else {
                            cutflag = false;
                            $(".container").css({display: "block"});
                        }
                    }
                    arr.push(obj.getImageData(0, 0, this.graffit.width, this.graffit.height));
                    this.setSaveGraffitiPicture('submit')
                }
            },
            //获取Canvas
            getCanvas(){
                var canvas = document.getElementById('myCanvas');
                var obj = canvas.getContext("2d");
                return {canvas:canvas,obj:obj}
            },
            //切换涂鸦工具
            setGraffitiTool(type){
                this.graffit.tool = type;
            },
            //切换填充描边
            setGraffitiFill(type){
                this.graffit.style = type;
            },
            //撤销Graffiti
            revokeGraffiti(){
                let arr = this.graffit.arr;
                let obj = this.getCanvas().obj;
                arr.pop();
                obj.clearRect(0, 0, this.graffit.width, this.graffit.height);
                if (arr.length > 0) {
                    obj.putImageData(arr[arr.length - 1], 0, 0, 0, 0, this.graffit.width, this.graffit.height);
                }
            },
            //清除Graffiti
            cleanGraffiti(){
                this.graffit.arr = [];
                let obj = this.getCanvas().obj;

                obj.clearRect(0, 0, this.graffit.width, this.graffit.height);
            }
        },
        mounted() {
            this.getElementContent(this.id);
            this.linkSignalR(this.id);
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .preview_TS {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        z-index: 1999;
        position: relative;

        .preview {
            .FCanvas_Page {
                position: relative;
                margin: 0 auto;
                background: #fff;
                height: 1080px;
                width: 1200px;
                margin-top: 30px;

                .FCharsDrog {
                    /*background-color: #00a65a;*/
                    z-index: 0;
                    position: absolute;

                    .charts_box {
                        width: 100%;
                        height: 100%;
                        color: #fff;
                        font-size: 30px;
                        text-align: center;
                    }

                    .text_input {
                        width: 100%;
                        height: 100%;
                        outline: none;
                        resize: none;
                        border: none;
                        background: transparent;
                        /*transform: scale(0.96);*/
                    }

                    .text_img {
                        width: 100%;
                        height: 100%;
                    }

                    .text_svg {
                        width: 100%;
                        height: 100%;

                        > * {
                            width: 100%;
                            height: 100%;
                        }

                        .ellipse {
                            transform: scale(0.498);
                        }
                    }
                }

                .chart-barder {
                    position: absolute;
                    z-index: 999;
                }

                .linBorTop {
                    border-top: 1px dashed #999;
                }

                .linBorLeft {
                    border-left: 1px dashed #999;
                }

                .chart-xy-barder-top {
                    width: 100%;
                    .linBorTop;
                }

                .chart-xy-barder-bottom {
                    width: 100%;
                    .linBorTop;
                }

                .chart-xy-barder-left {
                    height: 100%;
                    .linBorLeft;
                }

                .chart-xy-barder-right {
                    height: 100%;
                    .linBorLeft;
                }
            }

            .graffiti {
                width: 100%;
                height: 100%;
                position: absolute;
                z-index: 999;
                margin-top: 30px;
                #myCanvas {
                    background: rgba(255, 255, 255, 0.2);
                    margin: 0 auto;
                    display: block;
                }
            }

            .el-scrollbar {
                width: 100%;
                height: 100%;

                .el-scrollbar__wrap {
                    overflow-x: hidden;
                }

                .el-scrollbar__view {
                    .FCanvas_Page {
                        position: relative;
                        margin: 0 auto;
                        background: #fff;
                        height: 1080px;
                        width: 1200px;

                        .FCharsDrog {
                            /*background-color: #00a65a;*/
                            z-index: 0;
                            position: absolute;

                            .charts_box {
                                width: 100%;
                                height: 100%;
                                color: #fff;
                                font-size: 30px;
                                text-align: center;
                            }

                            .text_input {
                                width: 100%;
                                height: 100%;
                                outline: none;
                                resize: none;
                                border: none;
                                background: transparent;
                                /*transform: scale(0.96);*/
                            }

                            .text_img {
                                width: 100%;
                                height: 100%;
                            }

                            .text_svg {
                                width: 100%;
                                height: 100%;

                                > * {
                                    width: 100%;
                                    height: 100%;
                                }

                                .ellipse {
                                    transform: scale(0.498);
                                }
                            }
                        }

                        .chart-barder {
                            position: absolute;
                            z-index: 999;
                        }

                        .linBorTop {
                            border-top: 1px dashed #999;
                        }

                        .linBorLeft {
                            border-left: 1px dashed #999;
                        }

                        .chart-xy-barder-top {
                            width: 100%;
                            .linBorTop;
                        }

                        .chart-xy-barder-bottom {
                            width: 100%;
                            .linBorTop;
                        }

                        .chart-xy-barder-left {
                            height: 100%;
                            .linBorLeft;
                        }

                        .chart-xy-barder-right {
                            height: 100%;
                            .linBorLeft;
                        }
                    }

                    .graffiti {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        z-index: 999;

                        .container {
                            width: 250px;
                            height: 60px;
                            position: fixed;
                            left: 15px;
                            top: 70px;
                        }

                        .container h2 {
                            width: 100%;
                            height: 60px;
                            font-size: 22px;
                            text-align: center;
                            color: #ff377e;
                            font-weight: normal;
                            line-height: 60px;
                            border-bottom: 1px solid #000;
                        }

                        .container h3 {
                            width: 100%;
                            height: 30px;
                            font-size: 18px;
                            text-align: center;
                            color: #41b1ff;
                            font-weight: normal;
                            line-height: 30px;
                        }

                        .row {
                            width: 100%;
                            height: auto;
                            background-color: rgba(192, 192, 192, 0.50);
                            overflow: hidden;
                        }

                        .type {
                            width: 100%;
                            height: auto;
                            margin: 20px 0;
                            padding-bottom: 10px;
                            border-bottom: 1px solid #fff;
                        }

                        .type:after {
                            content: "";
                            display: block;
                            clear: both;
                        }

                        .type li {
                            float: left;
                            width: 90px;
                            height: 45px;
                            margin: 0 auto;
                            background-color: #0078ff;
                            color: #fff;
                            font-size: 18px;
                            line-height: 45px;
                            text-align: center;
                            margin-bottom: 15px;
                            border-radius: 5px;
                            cursor: pointer;
                            transition: all 0.7s;
                        }

                        .type li:hover {
                            background-color: #fff;
                            color: #0078ff;
                            box-shadow: 0 0 10px rgba(0, 120, 255, 0.77);
                        }

                        .type .typeactive {
                            background-color: #fff;
                            color: #0078ff;
                            box-shadow: 0 0 10px rgba(0, 120, 255, 0.77);
                        }

                        .type li:nth-child(odd) {
                            margin-left: 25px;
                        }

                        .type li:nth-child(even) {
                            margin-left: 20px;
                        }

                        .style {
                            width: 100%;
                            height: 40px;
                        }

                        .style li {
                            float: left;
                            width: 90px;
                            height: 45px;
                            background-color: #FFBC00;
                            color: #fff;
                            font-size: 18px;
                            line-height: 45px;
                            text-align: center;
                            border-radius: 5px;
                            cursor: pointer;
                            transition: all 0.7s;
                        }

                        .style li:hover {
                            color: #ffa800;
                            background-color: #fff;
                            box-shadow: 0 0 10px rgba(255, 232, 95, 0.77);
                        }

                        .style .styleactive {
                            color: #ffa800;
                            background-color: #fff;
                            box-shadow: 0 0 10px rgba(255, 232, 95, 0.77);
                        }

                        .style li:nth-child(1) {
                            margin-left: 25px;
                        }

                        .style li:nth-child(2) {
                            margin-left: 20px;
                        }

                        .poly {
                            position: relative;
                        }

                        .bian {
                            position: absolute;
                            left: 100px;
                            top: 0;
                            width: 90px;
                            height: auto;
                            border-radius: 5px;
                            background-color: #EC494E;
                            overflow: hidden;
                            overflow: hidden;
                            transform: scale(1.2);
                            display: none;
                        }

                        .bian span {
                            display: block;
                            float: left;
                            width: 40px;
                            height: 45px;
                            font-size: 16px;
                            color: #fff;
                            text-align: center;
                            line-height: 40px;
                            color: #fff;
                            transition: all 0.7s;
                        }

                        .bian input {
                            float: left;
                            width: 45px;
                            height: 35px;
                            margin-top: 5px;
                            border: 1px solid #fff;
                            box-sizing: border-box;
                            text-align: center;
                            line-height: 40px;
                            font-size: 18px;
                            color: #fff;
                            background: #EC494E;
                            border-radius: 3px;
                            box-shadow: 0 0 0 4px #fff inset;
                            transition: all 0.7s;
                        }

                        .cut, .create, .back {
                            float: left;
                            width: 90px;
                            height: 45px;
                            margin-left: 25px;
                            margin-bottom: 15px;
                            background-color: #5bd219;
                            color: #fff;
                            font-size: 18px;
                            line-height: 45px;
                            text-align: center;
                            border-radius: 5px;
                            cursor: pointer;
                        }

                        .copy, .clear, .save {
                            float: left;
                            width: 90px;
                            height: 45px;
                            margin-left: 20px;
                            margin-bottom: 15px;
                            background-color: #5bd219;
                            color: #fff;
                            font-size: 18px;
                            line-height: 45px;
                            text-align: center;
                            border-radius: 5px;
                            cursor: pointer;
                        }

                        .shezhi {
                            transition: all 0.7s;
                        }

                        .shezhistyle {
                            background: #fff;
                            color: #5bd219;
                        }

                        .create {
                            position: relative;
                        }

                        .xinjian {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 200px;
                            height: 165px;
                            border-radius: 5px;
                            background-color: #EC494E;
                            box-shadow: 0 0 15px rgba(236, 73, 78, 0.76);
                            cursor: default;
                            display: none;
                        }

                        .xinjian:hover {
                            color: #fff;
                        }

                        .xinjian_before {
                            position: absolute;
                            right: 0;
                            top: 0;
                            width: 20px;
                            height: 20px;
                            color: #fff;
                            line-height: 16px;
                            text-indent: -1px;
                            font-size: 30px;
                            border: 1px solid #fff;
                            transform: rotate(45deg);
                            border-radius: 50%;
                            cursor: pointer;
                        }

                        .xinjian h6 {
                            width: 100%;
                            height: 50px;
                            color: #fff;
                            line-height: 50px;
                            text-align: center;
                            font-size: 20px;
                            font-weight: normal;
                        }

                        #ding {
                            width: 60px;
                            height: 30px;
                            font-size: 14px;
                            border-radius: 3px;
                            color: #fff;
                            background-color: #0078ff;
                            border: 0;
                            outline: none;
                            cursor: pointer;
                            box-shadow: 0 0 10px rgba(0, 120, 255, 0.5);
                        }

                        .xinjian_width, .xinjian_height {
                            float: left;
                            width: 85px;
                            height: 40px;
                            margin-left: 10px;
                            border-radius: 5px;
                            margin-bottom: 20px;
                            background-color: #FFBC00;
                        }

                        .xinjian_width:hover, .xinjian_height:hover {
                            background-color: #fff;
                            color: #000;
                        }

                        .xinjian_width span, .xinjian_height span {
                            float: left;
                            width: 30px;
                            height: 100%;
                            font-size: 16px;
                            text-align: center;
                            line-height: 40px;
                        }

                        .xinjian_width input, .xinjian_height input {
                            float: left;
                            margin-top: 5px;
                            width: 50px;
                            height: 30px;
                            text-align: center;
                            line-height: 30px;
                            font-size: 14px;
                            border: 1px solid #FFBC00;
                            box-sizing: border-box;
                        }

                        .box {
                            float: left;
                            width: 90px;
                            height: auto;
                            background-color: #EC494E;
                            overflow: hidden;
                            border-radius: 5px;
                            transition: all 0.7s;
                        }

                        .box {
                            margin-left: 25px;
                        }

                        .linewidth {
                            margin-left: 20px;
                        }

                        .box:hover {
                            background-color: #fff;
                        }

                        .box span {
                            display: block;
                            float: left;
                            width: 40px;
                            height: 45px;
                            font-size: 16px;
                            color: #fff;
                            text-align: center;
                            line-height: 40px;
                            color: #fff;
                            transition: all 0.3s;
                        }

                        .box input {
                            float: left;
                            width: 45px;
                            height: 35px;
                            margin-top: 5px;
                            border: 1px solid #fff;
                            box-sizing: border-box;
                            text-align: center;
                            line-height: 40px;
                            font-size: 18px;
                            color: #fff;
                            background: #EC494E;
                            border-radius: 3px;
                            box-shadow: 0 0 0 4px #fff inset;
                            transition: all 0.3s;
                        }

                        .box2 span {
                            width: 55px;
                        }

                        .box2 input {
                            width: 140px;
                        }

                        .space {
                            float: left;
                            width: 100%;
                            height: 0;
                            border-bottom: 1px solid #fff;
                            margin: 20px 0;
                        }

                        #myCanvas {
                            background: rgba(255, 255, 255, 0.2);
                            margin: 0 auto;
                            display: block;
                        }
                    }
                }

                .el-scrollbar__bar {
                    z-index: 999999999;
                }
            }

            .userList {
                position: fixed;
                left: 30px;
                top: 30px;
                width: 120px;
                height: 500px;

                > div {
                    color: #fff;
                }

                > ul {
                    > li {
                        color: #fff;
                        line-height: 30px;
                        text-indent: 10px;
                    }
                }
            }

        }

        .container_toolbar{
            width:777px;
            border-radius: 10px;
            margin: 0 auto;
            transform: translateX(-50%);
            left: 50%;
            position: fixed;
            border: 1px #000;
            border-style: solid;
            background: #e5e7df;
            z-index: 2000;
            cursor: pointer;

            >div{
                margin: 6px;
                border: 1px #000;
                border-style: dotted;
                border-radius: 5px;
                vertical-align: middle;
            }
            >span{
                >div{
                    margin: 6px;
                    border: 1px #000;
                    border-style: dotted;
                    border-radius: 5px;
                    vertical-align: middle;
                    >sup{
                        background-color: rgba(255,255,255,0);
                        color: #000;
                        border: none;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    }
                }
            }
            .tool{
                margin: 0;
                border: none;
            }
            .picker{
                z-index: 999999999999;
            }
            .number{
                width: 65px;
                >span{
                    width: 20px;
                }
                .el-input{
                    >input{
                        text-align: left;
                        padding-left: 5px;
                        padding-right: 25px;
                    }
                }
            }

            .select{
                background: #fff;
            }
        }

    }
</style>
